import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { logout } from 'redux/modules/auth/action';

const PrivateRoute = ({ component: Component, auth, canEnter, history, routerBridgeProps, ...rest }) => {
    return (
        <Route
            {...rest}
            render={(props) =>
                (auth.isAuthenticated && canEnter) || (!auth.isAuthenticated && !canEnter) ? (
                    <Component routerBridgeProps={routerBridgeProps} {...props} />
                ) : (
                    <Redirect to={{ path: '/', }}/>
                )
            }
        />
    );
};

const mapStateToProps = (state) => ({
    auth: state.auth,
});

export default connect(mapStateToProps, { logout, })(PrivateRoute);
